<template>
  <div class="share-project-block container my-3">
    <h6 class="create-project-header">
      {{ $resourceString["myProject.Project.ShareProject.Title"] }}
    </h6>
    <button type="button" class="wf-modal-button-close btn button-full" @click="hideModal('share-project')">
      <span aria-label="Close modal" class="png-icon png-icon-icons-glyph--k-close">
      </span>
    </button>
    <div class="my-3">
      <label class="label-before-switch label-size-12 text-uppercase" ref="shareProject">
        {{ $resourceString["common.Sharetray.Label.Link"] }}
      </label>
      <div class="mb-2 d-flex">
        <input type="text" class="form-control" id="sharable_link" v-model="projectUrl" aria-describedby="basic-addon3"
          disabled />
        <button type="button" class="copy-link-btn btn btn-primary py-0" @click.prevent="handleCopyUrl">Copy</button>
      </div>
      <div class="font-16 pb-3" style="color: gray;">
        <span class="font-16">{{
          $resourceString[
          "myProject.Project.ShareProject.SharableLinkDescription"
          ]
        }}</span>
      </div>

      <label for="invite_people-shareProject" class="label-size-12 text-uppercase">
        {{ $resourceString["account.ShareTray.Label.InvitePeople"] }}*
      </label>
      <div class="mb-2 d-flex justify-content-between align-items-center form-group-shareproject position-relative mb-2">
        <div class="input-group">
          <input type="text" class="form-control" id="invite_people-shareProject" v-model="newEmail"
            :placeholder="$resourceString['account.MyProject.EmailField.Placeholder']" @keydown.enter="addEmail" />
          <div class="input-group-append input-container-shareProject">
            <button class=" btn-primary small-button-shareProject "
              :class="newEmail.length <= 0 ? 'disabled-shareProject' : ''" @click.prevent="addEmail"
              :disabled="newEmail.length == 0">
              +
            </button>
          </div>
          <div class="input-group-append roles-dropdown-createProject">
            <div aria-haspopup="true" aria-expanded="true" id="board-roles-dropdown-toggle" type="button"
              class="border-0 btn btn-primary bg-white text-accent-black" data-toggle="dropdown">
              <span>
                {{ selectedRole.label }}
              </span>
              <span
                class="png-icon bg-light position-relative png-icon-icons-glyph--k-chevron-down mb-1 bg-transparent mr-0"></span>
            </div>
            <div class="rounded dropdown-menu dropdown-menu-right bg-white label-size-12">
              <a href="" v-for="(role, index) in roles" :key="index" class="dropdown-item" role="button"
                @click.prevent="selectRole(role)">
                <div class="item-texts d-flex justify-content-center" style="flex-direction: column;">
                  <span class="role-label role-label-font-wt text-uppercase">
                    {{ role.label }}
                  </span>
                  <span class="role-description">{{ role.description }}</span>
                </div>
                <div class="icon-holder" v-if="role === selectedRole">
                  <i class="fal fa-check" aria-hidden="true"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wf-current-refinements-group" v-for="(email, index) in emails" :key="index">
        <a class="btn btn-white shadow-sm mx-1 my-1 bg-dark text-light text-transform-none">
          {{ email }}

          <span class="png-icon png-icon-icons-glyph--k-close email-remove-icon"
            @click="removeEmail(index)">&times;</span></a>
      </div>
      <p class="text-danger font-16">
        {{
          validationError.registeredEmail
          ? $resourceString["virtualtray.Sharetray.Email.Role.Error"]
          : validationError.invitePeople
            ? $resourceString["virtualtray.Sharetray.Email.Required.Error"]
            : validationError.validEmail
              ? $resourceString["virtualtray.Sharetray.Email.ValidEmail.Error"]
              : ""
        }}
      </p>
      <label for="email_subject" class="label-size-12 text-uppercase">
        {{ $resourceString["account.ShareTray.Label.EmailSubject"] }}*
      </label>
      <div class=" mb-3">
        <input type="text" class="form-control" id="email_subject"
          :placeholder="$resourceString['account.MyProject.EmailFieldSubject.Placeholder']" v-model="emailSubject" />
        <p class="text-danger font-16" v-if="validationError.emailSubject">
          {{ $resourceString["virtualtray.Sharetray.Subject.Error"] }}
        </p>
      </div>
      <label for="tray-description" class="label-size-12 text-uppercase">
        {{ $resourceString["common.Sharetray.EmailNote.Label"] }}
        <span class="optional-field ml-3"> {{ $resourceString["contentWizard.Label.Field.Optional"] }} </span>
      </label>
      <div class="input-group mb-4">
        <textarea class="form-control" id="tray-description" v-model="emailNote" aria-label="With textarea"
          :placeholder="$resourceString['account.MyProject.EmailFieldNote.Placeholder']"></textarea>
      </div>
      <div class="send-btn-row row">
        <div class="send-btn-col col">
          <button class="btn btn-outline-primary" @click="shareTrayItem">
            {{
              $resourceString["myProject.Project.ShareProject.SendInvite.Title"]
            }}
          </button>
        </div>
      </div>
      <div id="who-has-access-to-project" class="accordion">
        <div class="card">
          <div class="card-header">
            <div @click.prevent="handleWHA" id="user-with-access-dropdown-toggle" type="button" data-toggle="collapse"
              data-target="#who-has-access" aria-expanded="false" aria-controls="who-has-access"
              class="who-has-access-hover label-size-12 text-uppercase">
              {{
                $resourceString[
                "myProject.Project.ShareProject.WhoHasAcess.label"
                ]
              }}
              {{ `(${getprojectUsers.length})` }}
              <span
                class="png-icon bg-light position-relative png-icon-icons-glyph--k-chevron-down mb-1 bg-transparent mr-0"
                :style="transform ? 'transform: rotate(180deg)' : ''"></span>
            </div>
          </div>
          <div class="collapse" id="who-has-access">
            <div class="false card-body">
              <ul class="users-with-access-list label-size-12 text-uppercase">
                <li v-for="user in getprojectUsers" class="users-with-access-list__item label-size-12">
                  <span class="name-email">
                    <span>{{ user.userName }}</span>
                    <span class="color-secondary text-lowercase">
                      {{ user.email }}
                    </span>
                  </span>
                  <span v-if="user.role === BoardRoles.owner">
                    {{
                      $resourceString["myProject.shareTray.Title.Dropdown.Owner"]
                    }}
                  </span>
                  <div v-else class="dropdown">
                    <span v-if="user.role === BoardRoles.collaborator && projectDetails.role != BoardRoles.owner">
                      {{
                        $resourceString[
                          "myProject.Project.ShareProject.Collaborator.Label"
                        ]
                      }}
                    </span>
                    <span
                      v-else-if="user.role === BoardRoles.viewer && projectDetails.role != BoardRoles.owner"
                    >
                      {{
                        $resourceString[
                          "myProject.Project.ShareProject.Viewer.Label"
                        ]
                      }}
                    </span>
                  </div>
                  <div v-if="projectDetails.role == BoardRoles.owner && checkRole(user.role) !== ownerResourceString" class="dropdown">
                    <my-project-roles-dropdown :checkRole="checkRole" :isRemoveAccess="isAdmin ? true : user.role == BoardRoles.owner ? true : user.email != userEmail" :user="user" :roles="roles" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button class="btn btn-outline-primary mt-2" @click="handleModalClose">
          {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
        </button>
        <div class="mt-2 float-right pb-4">
          <button class="btn btn-outline-primary" @click="handleStopSharing" v-if="projectDetails.role == BoardRoles.owner || isAdmin">
            {{
              $resourceString["myProject.Project.ShareProject.StopSharing.label"]
            }}
          </button>
          <button class="btn btn-primary" @click.prevent="handleSave" :disabled="isDisabled">
            {{ $resourceString["myProject.Project.ShareProject.Save.label"] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BoardRoles } from "../../../stepTree";
import myProjectRolesDropdown from "./my-project-roles-dropdown.vue";
export default {
  props: ["userEmail", "projectDetails", "productData", "userRole", "isAdmin"],
  data() {
    return {
      ownerResourceString: this.$resourceString["myProject.shareTray.Title.Dropdown.Owner"],
      transform: false,
      isPublic: true,
      BoardRoles: BoardRoles,
      roles: [
        {
          value: 'collaborator',
          label: this.$resourceString[
            "myProject.Project.ShareProject.Collaborator.Label"
          ],
          description: this.$resourceString[
            "myProject.Project.ShareProject.Collaborator.Description"
          ],
          role: 2,
          showAsOption: false
        },
        {
          value: 'viewer',
          label: this.$resourceString[
            "myProject.Project.ShareProject.Viewer.Label"
          ],
          description: this.$resourceString[
            "myProject.Project.ShareProject.Viewer.Description"
          ],
          role: 0,
          showAsOption: false
        }
      ],
      selectedRole: {
        value: 'collaborator',
        label: this.$resourceString[
          "myProject.Project.ShareProject.Collaborator.Label"
        ],
        description: this.$resourceString[
          "myProject.Project.ShareProject.Collaborator.Description"
        ],
        role: 2
      },
      emails: [],
      newEmail: "",
      isValid: false,

      projectUrl: "",
      projectId: "",
      emailSubject: null,
      emailNote: null,
      invitePeople: null,
      validationError: {
        emailSubject: false,
        invitePeople: false,
        registeredEmail: false,
        validEmail: false
      }
    };
  },
  computed: {
    ...mapGetters({
      trayOrders: "virtualTray/trayOrders",
      getprojectUsers: "myTray/getprojectUsers",
      getUserInfoEmail: "myTray/getUserInfoEmail",
      getUserEmaiFromVTpage: "myTray/getUserEmaiFromVTpage",
      getupdatedProjectUser: "myTray/getupdatedProjectUser",
      getinviteRole: "myTray/getinviteRole",
      getdeletedProjectUsers: "myTray/getdeletedProjectUsers"
    }),
    isDisabled() {
      return (
        this.getdeletedProjectUsers.length == 0 &&
        this.getupdatedProjectUser.length == 0
      );
    }
  },
  created() {
    const currentUrl = window.location.href;
    let urlParts = currentUrl.split("/");
    this.projectId = urlParts[urlParts.length - 1];
    if (urlParts.includes("Edit")) {
      this.projectId = urlParts[urlParts.length - 1];
    } else {
      this.projectId = null;
    }

    if (this.projectId) {
      this.projectUrl = new URL(window.location.href);
    } else {
      let newUrl = new URL(window.location.href);
      this.projectUrl =
        newUrl.origin + `/Project/Edit/${this.projectId}`;
    }
  },
  mounted() {
    this.resetShareProject();
  },
  methods: {
    ...mapActions({
      saveTray: "myTray/saveTray",
      shareTray: "myTray/shareTray",
      createShareTrayApi: "myTray/createShareTrayApi",
      resourceString: "myTray/resourceString",
      userRoleChangeHandler: "myTray/userRoleChangeHandler",
      userDeleteFromRoleListHandler: "myTray/userDeleteFromRoleListHandler",
      saveShareProject: "myTray/saveShareProject",
      updateStopSharing: "myTray/updateStopSharing",
      resetShareProject: "myTray/resetShareProject",
      urlCopied: "myTray/urlCopied"
    }),

    handleCopyUrl() {
      navigator.clipboard.writeText(this.projectUrl);
      this.resourceString(
        this.$resourceString["common.Copied.Msg"]
      );
      this.urlCopied()
    },

    handleWHA() {
      this.transform = !this.transform;
    },

    checkRole(role) {
      switch (role) {
        case BoardRoles.owner:
          return this.$resourceString[
            "myProject.shareTray.Title.Dropdown.Owner"
          ];
        case BoardRoles.collaborator:
          return this.$resourceString[
            "myProject.Project.ShareProject.Collaborator.Label"
          ];
        case BoardRoles.viewer:
          return this.$resourceString[
            "myProject.Project.ShareProject.Viewer.Label"
          ];
        default:
          return this.$resourceString[
            "myProject.shareTray.Title.Dropdown.UnknownRole"
          ];
      }
    },

    async handleSave() {
      let data = {
        boardId: this.projectId,
        deletedUsers:
          this.getdeletedProjectUsers.length > 0
            ? this.getdeletedProjectUsers.map(user => ({
              identityId: user.identityId,
              email: user.email,
              userName: user.userName,
              role: user.role,
              id: user.id,
              createdAt: user.createdAt,
              updatedAt: user.updatedAt
            }))
            : [],
        isAdmin: false,
        isPrivate: this.isPublic ? false : true,
        updatedUsers:
          this.getupdatedProjectUser.length > 0
            ? this.getupdatedProjectUser.map(user => ({
              identityId: user.identityId,
              email: user.email,
              userName: user.userName,
              role: user.role,
              id: user.id,
              createdAt: user.createdAt,
              updatedAt: user.updatedAt
            }))
            : []
      };
      await this.resourceString(
        this.$resourceString["common.Saved.Msg"]
      );
      await this.saveShareProject(data);
      this.resetShareProject();
      this.hideModal("share-project");
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    async handleStopSharing() {
      await this.updateStopSharing();
    },
    selectRole(role) {
      this.selectedRole = role;
    },

    addEmail() {
      if (this.newEmail) {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        let boolVaule = emailPattern.test(this.newEmail);
        if (this.getprojectUsers.filter(el => el.email === this.newEmail).length !== 0) {
          return this.validationError.registeredEmail = true
        }
        if (!boolVaule) {
          this.validationError.registeredEmail = false;
          this.validationError.invitePeople = false;
          return (this.validationError.validEmail = true);
        }
        if (
          this.getUserInfoEmail === this.newEmail ||
          this.userEmail === this.newEmail
        ) {
          this.validationError.validEmail = false;
          this.validationError.invitePeople = false;
          return (this.validationError.registeredEmail = true);
        }
        if (boolVaule) {
          this.emails.push(this.newEmail);
          this.newEmail = "";
          this.isValid = false;
          this.validationError.registeredEmail = false;
          this.validationError.validEmail = false;
          this.validationError.invitePeople = false;
        }
      }
    },

    removeEmail(index) {
      this.emails.splice(index, 1);
    },

    async shareTrayItem() {
      this.validationError.emailSubject = false;
      this.validationError.invitePeople = false;
      this.validationError.registeredEmail = false;
      this.validationError.validEmail = false;
      let validationStatus = true;
      if (!this.emailSubject) {
        this.validationError.emailSubject = true;
        validationStatus = false;
      }
      if (this.emails.length == 0 || this.isValid) {
        this.validationError.invitePeople = true;
        validationStatus = false;
      }
      if (validationStatus) {
        let createShareTrayData = {
          boardId: this.projectId,
          emails: this.emails,
          role: this.selectedRole.role,
          isAdmin: false
        };
        await this.createShareTrayApi(createShareTrayData);

        let data = {
          EmailNote: this.emailNote,
          Recipients: this.emails,
          boardId: this.projectId,
          subject: this.emailSubject,
          isProject: true
        };
        await this.resourceString(
          this.$resourceString["common.Shared.Msg"]
        );
        await this.shareTray(data);
        this.emailSubject = null;
        this.emailNote = null;
        this.newEmail = "";
        this.emails = [];
        this.selectedRole = {
          value: 'collaborator',
          label: this.$resourceString[
            "myProject.Project.ShareProject.Collaborator.Label"
          ],
          description: this.$resourceString[
            "myProject.Project.ShareProject.Collaborator.Description"
          ],
          role: 2
        };
      }
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    handleModalClose() {
      this.hideModal("share-project");
    }
  },
  components: {
    myProjectRolesDropdown
  }
};
</script>
